import { AllContentTypeIds } from './models/Content';

export const ASSETS_DOMAINS_MAP = {
    'images.ctfassets.net': 'static-images.my.telia.lt',
    'assets.ctfassets.net': 'static-assets.my.telia.lt',
    'downloads.ctfassets.net': 'static-downloads.my.telia.lt',
    'videos.ctfassets.net': 'static-video.my.telia.lt',
};

export const CMS_QUERY_KEY = {
    CONTENT_SLOT: 'CONTENT_SLOT',
};

export const PREVIEWABLE_CONTENT_TYPE_IDS: AllContentTypeIds[] = [
    'blockContent',
    'blockProducts',
    'blockPromo',
    'blockLegalText',
    'blockQuickLink',
    'blockText',
    'blockValuePrompt',
    'blockWidget',
    'banner',
    'notificationBanner',
    'blockFaq',
    'blockCta',
    'blockArticles',
    'blogSection',
    'layout',
    'serviceDescription',
    'leadForm',
];

export const BLOG_BASE_PATH = '/blog';
export const BLOG_AUTHOR_SUBPATH = '/ekspertai';
export const BLOG_TAG_SUBPATH = '/zyma';

export const CONTENT_TYPE_TO_URL_SLUG_MAP: Record<AllContentTypeIds, string> = {
    ...PREVIEWABLE_CONTENT_TYPE_IDS.reduce(
        (acc, contentType) => ({ ...acc, [contentType]: '/content-preview' }),
        {} as Record<AllContentTypeIds, string>,
    ),
    layout: '/layout-preview',
    notificationBanner: '/layout-preview',
    blogArticle: `${BLOG_BASE_PATH}/{slug}`,
    blogCategory: `${BLOG_BASE_PATH}/{slug}`,
    blogAuthor: `${BLOG_BASE_PATH}${BLOG_AUTHOR_SUBPATH}/{slug}`,
    blogTag: `${BLOG_BASE_PATH}${BLOG_TAG_SUBPATH}/{slug}`,
};
